import React from 'react'
import { reduxForm, Field } from 'redux-form'

import classNames from './PresentOptionsForm.css'
import Modal from '../modals/Modal'
import ConfirmButtons from '../ConfirmButtons'
import { pluralize } from '../../utils/string'
import { SORT_ARRAY } from '../../constants'

function PresentOptionsForm ({ handleSubmit, onCancel, confirmText, ...fieldProps }) {
  return (
    <Modal title='Presentation Options' onClose={onCancel}>
      <form onSubmit={handleSubmit} className={classNames.form}>
        <PresentOptionsFields {...fieldProps} />
        <ConfirmButtons
          confirmText={confirmText}
          onConfirm={handleSubmit}
          onCancel={onCancel}
        />
      </form>
    </Modal>
  )
}

export function PresentOptionsFields ({ imageSelection, defaultSort, presentTypeSelected, hideSort, rangeInputType }) {
  return (
    <div>
      <label>
        Presentation Type
        <br />
        <Field component='select' name='presentation_type' className={classNames.select}>
          <option value='kenburns'>Ken Burns</option>
          <option value='floating'>Floating</option>
        </Field>
      </label>
      {!hideSort &&
        <label>
          Presentation Sort Order
          <br />
          <Field component='select' name='presentation_sort' className={classNames.select}>
            {imageSelection
              ? <option value=''>Selection order</option>
              : <option value=''>Album Default ({defaultSort})</option>
            }
            {SORT_ARRAY.map(option => <option key={option.value} value={option.value}>{option.name}</option>)}
          </Field>
        </label>
      }
      {(!presentTypeSelected || presentTypeSelected === 'kenburns') &&
        <label>
          Slide duration
          <Field
            component={Slider}
            name='presentation_speed'
            defaultValue={3}
            props={{ min: 1, max: 30, step: 1, rangeInputType }}
          />
        </label>
      }
      {(!presentTypeSelected || presentTypeSelected === 'kenburns') &&
        <label>
          Transition speed
          <Field
            component={Slider}
            name='presentation_transition'
            defaultValue={1}
            props={{ min: 0.5, max: 20, step: 0.5, rangeInputType }}
          />
        </label>
      }
      {presentTypeSelected === 'floating' &&
        <label>
          Average slide duration
          <Field
            component={Slider}
            name='presentation_speed'
            defaultValue={30}
            props={{ min: 20, max: 60, step: 1, rangeInputType }}
          />
        </label>
      }
      {presentTypeSelected === 'floating' &&
        <label>
          Slide frequency
          <Field
            component={Slider}
            name='presentation_transition'
            defaultValue={5}
            props={{ min: 1, max: 10, step: 1, prefix: 'Every ', rangeInputType }}
          />
        </label>
      }
    </div>
  )
}

const Slider = ({ value, onChange, min, max, step, prefix = '', rangeInputType = 'range' }) => (
  <div>
    <span className={classNames.optionValue}>
      {prefix}{pluralize(value, 'second')}
    </span>
    <input
      value={value}
      onChange={onChange}
      type={rangeInputType}
      min={min}
      max={max}
      step={step}
      className={classNames.slider}
    />
  </div>
)

export default reduxForm({ form: 'present' })(PresentOptionsForm)



// WEBPACK FOOTER //
// ./src/components/present/PresentOptionsForm.js